export const products = {
  boards: [
    {
      id: "b1",
      name: "The Maverick Shortboard",
      price: 649.99,
      image: "https://images.unsplash.com/photo-1531722569936-825d3dd91b15?q=80&w=800&auto=format&fit=crop",
      tag: "Best Seller"
    },
    {
      id: "b2",
      name: "Noserider Classic Longboard",
      price: 899.00,
      image: "https://images.unsplash.com/photo-1537048386375-7b561cda5dc0?q=80&w=800&auto=format&fit=crop",
      tag: "New Arrival"
    },
    {
      id: "b3",
      name: "Twin Fin Fish",
      price: 580.00,
      image: "https://images.unsplash.com/photo-1596541578135-2d7c07b4618e?q=80&w=800&auto=format&fit=crop"
    }
  ],
  wetsuits: [
    {
      id: "w1",
      name: "Thermal 4/3mm Fullsuit",
      price: 289.50,
      image: "https://images.unsplash.com/photo-1581027581561-12c8ff1f29ba?q=80&w=800&auto=format&fit=crop",
      tag: "Cold Water"
    },
    {
      id: "w2",
      name: "Spring Suit 2mm",
      price: 145.00,
      image: "https://images.unsplash.com/photo-1533560029705-7798c8c22736?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "w3",
      name: "UV Protection Rashguard",
      price: 45.00,
      image: "https://images.unsplash.com/photo-1520626880016-52bdff4a2f87?q=80&w=800&auto=format&fit=crop"
    }
  ],
  accessories: [
    {
      id: "a1",
      name: "Pro Surf Leash 6ft",
      price: 32.00,
      image: "https://images.unsplash.com/photo-1621508681729-ea267104b207?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "a2",
      name: "Sticky Bumps Wax (6-Pack)",
      price: 18.00,
      image: "https://images.unsplash.com/photo-1618142750398-31cd1b110190?q=80&w=800&auto=format&fit=crop",
      tag: "Essential"
    },
    {
      id: "a3",
      name: "FCS II Performance Fins",
      price: 110.00,
      image: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?q=80&w=800&auto=format&fit=crop"
    }
  ]
};

export const reviews = [
  {
    id: 1,
    name: "Kai L.",
    location: "Oahu, HI",
    text: "The Maverick shortboard changed my entire approach to steep drops. Incredible projection out of the bottom turn. Tidecraft's quality is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah M.",
    location: "Santa Cruz, CA",
    text: "Got the 4/3mm fullsuit for winter swells. Kept me toasty for a 3-hour session when it was easily 50 degrees in the water. Highly recommend.",
    rating: 5
  },
  {
    id: 3,
    name: "Jake T.",
    location: "Gold Coast, AUS",
    text: "The Starter Quiver Bundle was exactly what I needed to get back into the water after years away. Great value and killer aesthetic.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "How much is shipping for surfboards?",
    answer: "We offer flat-rate shipping of $99 for all surfboards within the continental US. Accessories and apparel ship free on orders over $50."
  },
  {
    question: "What is your return policy?",
    answer: "Unused gear in original packaging can be returned within 30 days of delivery. Surfboards must be completely unridden and without wax for a full refund minus shipping costs."
  },
  {
    question: "Do you offer custom board dimensions?",
    answer: "Currently, we focus on perfectly dialed-in stock dimensions for our models to ensure consistent magic. However, check out our 'Volume Calculator' to find your perfect stock size."
  },
  {
    question: "How do I care for my Tidecraft wetsuit?",
    answer: "Rinse thoroughly with fresh water after every session. Hang to dry in the shade on a thick plastic hanger (never wire). Avoid direct sunlight when drying."
  }
];